import React from 'react';

import * as routePaths from '../../../consts/route/routePaths';
import routerService from '../../../services/routerService';
import RegistrationHolder from './RegistrationHolder';

const RegistrationHolderPopup = (props) => {
    const location = routerService.getCurrent();
    const isRegistrationPage = location === routePaths.REGISTRATION;

    // If it is registration page -> RegistrationHolder will be displayed from DeviceRegistrationPage component
    if (isRegistrationPage) {
        return null;
    }

    return <RegistrationHolder {...props} />;
};

export default RegistrationHolderPopup;
